import { FilterSettings } from 'components/tables/Table.interfaces';
import { ProductAccessStatus } from 'domain/product/enums';
import { getProductRegistration } from './getProductRegistration';
import { MontelAccount } from 'domain/account/interfaces';

export const columnFilters = (
	productName: string,
): FilterSettings<MontelAccount> => ({
	treatGroupsAsSingle: false,
	groups: [
		{
			columnId: 'accessStatus',
			filters: [
				{
					id: 'accessStatus.all',
					text: 'All',
					value: undefined,
					selected: true,
				},
				{
					text: 'Allowed',
					value: ProductAccessStatus.Allowed,
					selected: false,
				},
				{
					text: 'Denied',
					value: ProductAccessStatus.Denied,
					selected: false,
				},
			],
		},
		{
			columnId: 'markReviewed',
			groupCanBeCleared: true,
			filters: [
				{
					text: 'Pending review',
					value: false,
					showCount: true,
					countFn: (users: MontelAccount[]) =>
						users?.filter(
							(u) =>
								getProductRegistration(
									u.productRegistrations,
									productName,
								)?.reviewed == false,
						).length,
					selected: false,
				},
			],
		},
		{
			columnId: 'email',
			groupCanBeCleared: true,
			filters: [
				{
					text: 'Hide unverified',
					value: 'hide-unverified',
					selected: false,
				},
			],
		},
	],
});
